import React, { Fragment, useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import country_currency from "./country_currency.json";
import { Multiselect } from "multiselect-react-dropdown"; 

function Product() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueImage, setIsTrueIMg] = React.useState(false);  
  const [isTrueOfferUrl, setIsTrueOfferUrl] = React.useState([{status:'false', index: 0 }]);  
  const [inputFieldsJp9, setInputFieldsJp9] = useState([{
    gtin8:'',
    sku:'',
    gtin13:'',
    gtin14:'',
    mpn:'',
}])

  const [selectedVal, setSelectedVal] = useState([{}]);
  const [inputFieldsEv1, setInputFieldsEv1] = useState({
    type: "ListItem",
    position: 1,
    name: '',
    description: '',
    image:'',
    startDate:'',
    endDate:'',
    starttime:'',
    endtime:'',
    eventStatus:'',
    eventAttend:'',
    vennuname:'',
    streetAddress:'',
    city:'',
    stream_url:'',
    statepresgion:'',
    performerName:'',
    zipcode:'',
    country:'',
    currency:'',
    brand:'',
    ratingValue:'',
    bestRating:'',
    worstRating:'',
    ratingCount:'',
    

  })
  const [inputFieldsEv, setInputFieldsEv] = useState([{
    reviewname:"",reviewBody:"",rating:"",datePublished:"",
      author: '',
      publisher: ''

  }])
  const sportsData = [
    { id: 'sku', name: 'sku' },
    { id: 'gtin8', name: 'gtin8' },
    { id: 'gtin13', name: 'gtin13' },
    { id: 'gtin14', name: 'gtin14' },
    { id: 'mpn', name: 'mpn' }
  ];
   
  
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange9 = (event) => { 
    let value = event.target.value;
    let name = event.target.name;
    setInputFieldsJp9((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
  }
  const handleChange8 = (newState = {}) => {
    const tempState = { ...selectedVal, ...newState };
    setSelectedVal(tempState); 
  };
  const handleChange4 = (newState = {}) => { 
    //setInputFieldsJp9(newState);
    setSelectedVal(newState);
  };
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name === 'image'){
      let isTrueImage = !value || urlPatternValidation(value);
      if(isTrueImage === false)
      {
        setIsTrueIMg(true);
      }
      else{
        setIsTrueIMg(false);
      }
    }
    setInputFieldsEv1((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
     
  }
  const handleChange2 = (indexs, evnt) => {
    const { name, value } = evnt.target;
    //isTrueOfferUrl
    if(name === 'offerurl'){
      let isTrueOfferUrl = !value || urlPatternValidation(value);
      if(isTrueOfferUrl === false)
      {
        setIsTrueOfferUrl({status:true, index:indexs});
      }
      else{
        setIsTrueOfferUrl({status:false, index:indexs});
      }
    }
    const list = [...inputFieldsEv];
    list[indexs][name] = value;
    setInputFieldsEv(list);
  } 
  function MyButton(props) {
    return <button {...props} />
  }
    
  const addInputFieldEv = () => {
    setInputFieldsEv([...inputFieldsEv, {
      reviewname:"",reviewBody:"",rating:"",datePublished:"",
      author: "",
      publisher: ""
    }]) 
  }
  const removeInputFieldsEv = (index) => {
    const rows = [...inputFieldsEv];
    rows.splice(index, 1);
    setInputFieldsEv(rows);
  } 
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
  
  
 
  const review = (inputFieldsEv.length === 1)?
   `"review": {
    "@type": "Review",
    "name": "`+inputFieldsEv[0].reviewname+`",
    "reviewBody": "`+inputFieldsEv[0].reviewBody+`",
    "datePublished": "`+inputFieldsEv[0].datePublished+`",
    "author": {"@type": "Person", "name": "`+inputFieldsEv[0].author+`"},
    "publisher": {"@type": "Organization", "name": "`+inputFieldsEv[0].publisher+`"}
  }`:`"review":[`+
  inputFieldsEv.map((items) =>
    JSON.stringify(items)
  )
  + `]`;
  const offer = (inputFieldsEv1.offertype==='Offer')?`"offers": {
    "@type": "Offer",
    "url": "`+inputFieldsEv1.url+`",
    "priceCurrency": "`+inputFieldsEv1.pricecurrency+`",
    "price": "`+inputFieldsEv1.price+`",
    "priceValidUntil": "`+inputFieldsEv1.priceValidUntil+`",
    "availability": "https://schema.org/`+inputFieldsEv1.availability+`",
    "itemCondition": "https://schema.org/`+inputFieldsEv1.itemCondition+`"
  },`:(inputFieldsEv1.offertype==='Aggregate Offer')?`"offers": {
    "@type": "AggregateOffer",
    "url": "`+inputFieldsEv1.url+`",
    "priceCurrency": "`+inputFieldsEv1.pricecurrency+`",
    "lowPrice": "`+inputFieldsEv1.lowprice+`",
    "highPrice": "`+inputFieldsEv1.highprice+`",
    "offerCount": "`+inputFieldsEv1.offerCount+`"
  },`:'';
  const brand = `"brand": {
    "@type": "Brand",
    "name": "`+inputFieldsEv1.brand+`"
  },`;
  let indentifier =  ( Object.keys(selectedVal[0])) && selectedVal &&  Object.values(selectedVal).map((data, index)=>{
     if(Object.keys(data).length > 0){
      let {name} = data; 
      let valdata = (name==="sku")?(inputFieldsJp9.sku !==undefined)?inputFieldsJp9.sku:'':(name==="gtin8")?(inputFieldsJp9.gtin8 !==undefined)?inputFieldsJp9.gtin8:'':(name==="gtin13")?(inputFieldsJp9.gtin13 !==undefined)?inputFieldsJp9.gtin13:'':(name==="gtin14")?(inputFieldsJp9.gtin14 !==undefined)?inputFieldsJp9.gtin14:'':(name==="mpn")?(inputFieldsJp9.mpn !==undefined)?inputFieldsJp9.mpn:'':'';
      return (index=== Object.keys(selectedVal).length-1)?'"'+name+'": "'+valdata+'",':'"'+name+'": "'+valdata+'"' ; 
     }
  });
  indentifier = (indentifier === false)?'':indentifier;
  const EvIsMyCopy = `<script type="application/ld+json">
  {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "`+inputFieldsEv1.name+`",
      "description": "`+inputFieldsEv1.description+`",
      "image": "`+inputFieldsEv1.image+`",
      `+brand+`
      `+indentifier+`
      `+offer+`
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "`+inputFieldsEv1.ratingValue+`",
        "bestRating": "`+inputFieldsEv1.bestRating+`",
        "worstRating": "`+inputFieldsEv1.worstRating+`",
        "ratingCount": "`+inputFieldsEv1.ratingCount+`"
      },
      `+review+`
  }
  </script><!--ProductList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;

  const resetFun = () =>{
    const sws_rows = {
      type: "ListItem",
      position: 1,
      name: '',
      description: '',
      image:'',
      startDate:'',
      endDate:'',
      starttime:'',
      endtime:'',
      eventStatus:'',
      eventAttend:'',
      vennuname:'',
      streetAddress:'',
      city:'',
      stream_url:'',
      statepresgion:'',
      performerName:'',
      zipcode:'',
      country:'',
      currency:'',
      brand:'',
      ratingValue:'',
      bestRating:'',
      worstRating:'',
      ratingCount:'',  
      offertype:''
    };
    setInputFieldsEv1(sws_rows);  
    setInputFieldsEv([{
      reviewname:"",reviewBody:"",rating:"",datePublished:"",
        author: '',
        publisher: ''
  
    }])
    setSelectedVal([{}]);
  }  
  return (
    <div className='container-flude'> 
        <div className='row mt-5 product_row'>
          <div className='col-md-8 ps-0 mb-5 border'>
            <div className='mt-2 mb-2 article_title'><i className="fa-solid fa-tag me-3"></i><b>Product - Offer, AggregateRating, Reviews</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Name</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.name} name="name" className="form-control"/>
                  </div>
                </div>
                <div className="col-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Image URL</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.image} name="image" className="form-control"/>
                  </div>
                  {isTrueImage && (
                    <div style={{ color: "#F61C04" }}>URL is not valid.</div>
                  )}
                </div>
                <div className="col-6 pe-0">
                  <div className="form-group me-2 mb-2">
                  <label>Brand</label>
                    <input type="url" onChange={(evnt) => handleChange5(evnt)}  value={inputFieldsEv1.brand} name="brand" className="form-control"/>
                  </div>
                </div>
                <div className="col-6 ps-0">
                  <div className="form-group me-2 mb-2">
                  <label>Descriptions</label>
                    <input type="url" onChange={(evnt) => handleChange5(evnt)}  value={inputFieldsEv1.description} name="description" className="form-control"/>
                  </div>
                </div>
                <div className="col-md-6 pe-0">
                  <label>Identification properties</label>
                  <div className="form-group me-2 mb-2"> 
                    <Multiselect
                      options={sportsData}
                      name="unitText"
                      displayValue="name"
                      showCheckbox={true}
                      onRemove={(evnt) => handleChange4(evnt)}
                      onSelect={(evnt) => handleChange8(evnt)}
                    />
                  </div>
                </div>
                <div className='col-md-6 ps-0'>   
                    { (Object.keys(selectedVal[0]).length> 0) && selectedVal &&  Object.values(selectedVal).map((data)=>{
                      let {name, id} = data; 
                      let valdata = (name==="sku")?inputFieldsJp9.sku:(name==="sku")?inputFieldsJp9.Twitter:(name==="gtin8")?inputFieldsJp9.gtin8:(name==="gtin13")?inputFieldsJp9.gtin13:(name==="gtin14")?inputFieldsJp9.gtin14:(name==="mpn")?inputFieldsJp9.mpn:'';
                      return (
                        <div className="form-group me-2 mb-2" key={id}>
                          <input type="text" onChange={(evnt) => handleChange9(evnt)} value={valdata} name={name} className="form-control" placeholder={name} />
                        </div>
                      )
                    })
                    }
                </div>  
                <div className="col-6 pe-0">
                  <label>Offer @type</label>
                  <div className="form-group me-2 mb-2">
                    <select onChange={(evnt) => handleChange5(evnt)} className='form-control' name="offertype" value={inputFieldsEv1.offertype}>
                      <option value="">
                        Select Event Status
                      </option>
                      <option value="Offer">
                        Offer
                      </option>
                      <option value="Aggregate Offer">
                        Aggregate Offer
                      </option>
                      <option value="None">
                        None
                      </option>
                    </select>  
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                
                <div className="col-6 ps-0">
                  <label>URL</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.url} name="url" className="form-control" placeholder="URL" />
                  </div>
                </div>
                <div className="col-6 pe-0">
                  <label>Price currency</label>
                  <div className="form-group me-2 mb-2">
                    <select className='form-control'  onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.pricecurrency} name="pricecurrency">
                        <option value="">
                          Select Currency
                        </option>
                        { country_currency.countries.country.map((calculatedata, index) => {
                            return (
                                <option key={index} value={calculatedata.currencyCode}>
                                    {calculatedata.countryName} {calculatedata.currencyCode}
                                </option>)})
                        }
                      </select>
                      <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                {inputFieldsEv1.offertype ==="Offer" &&
                  <Fragment>
                    <div className="col-6 pe-0">
                      <label>Price</label>
                      <div className="form-group me-2 mb-2">
                        <input type="number" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.price} name="price" className="form-control" placeholder="Price" />
                      </div>
                    </div>
                    <div className="col-6 ps-0">
                      <label>Price Valid Until</label>
                      <div className="form-group me-2 mb-2">
                        <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.priceValidUntil} name="priceValidUntil" className="form-control" />
                      </div>
                    </div>
                    <div className="col-6">
                      <label>Availability</label>
                      <div className="form-group me-2 mb-2">
                        <select onChange={(evnt) => handleChange5(evnt)} className='form-control' name="availability" value={inputFieldsEv1.availability}>
                          <option value="">
                            Select Event Status
                          </option>
                          <option value="InStock">
                            In Stock
                          </option>
                          <option value="OutOfStock">
                            Out Of Stock
                          </option>
                          <option value="OnlineOnly">
                            Online Only
                          </option>
                          <option value="InStoreOnly">
                            In StoreOnly
                          </option>
                          <option value="PreOrder">
                            Pre Order
                          </option>
                          <option value="PreSale">
                            Pre Sale
                          </option>
                          <option value="LimitedAvailability">
                            Limited Availability
                          </option>
                          <option value="SoldOut">
                            Sold Out
                          </option>
                          <option value="Discontinued">
                            Discontinued
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-6">
                      <label>Item condition</label>
                      <div className="form-group me-2 mb-2">
                        <select onChange={(evnt) => handleChange5(evnt)} className='form-control' name="itemCondition" value={inputFieldsEv1.itemCondition}>
                          <option value="">
                            Select Event Status
                          </option>
                          <option value="NewCondition">
                            New
                          </option>
                          <option value="UsedCondition">
                            Used
                          </option>
                          <option value="RefurbishedCondition">
                            Refurbished
                          </option>
                          <option value="DamagedCondition">
                            Damaged
                          </option>
                        </select>
                      </div>
                    </div>
                  </Fragment>
                }
                {inputFieldsEv1.offertype ==="Aggregate Offer" &&
                  <Fragment>
                    <div className="col-3">
                      <label>Low Price</label>
                      <div className="form-group me-2 mb-2">
                        <input type="number" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.lowprice} name="lowprice" className="form-control" placeholder="Low Price" />
                      </div>
                    </div>
                    <div className="col-3">
                      <label>High Price</label>
                      <div className="form-group me-2 mb-2">
                        <input type="number" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.highprice} name="highprice" className="form-control" placeholder='High Price' />
                      </div>
                    </div>
                    <div className="col-6">
                      <label>Number of Offers</label>
                      <div className="form-group me-2 mb-2">
                        <input type="number" onChange={(evnt) => handleChange5(evnt)} className='form-control' name="offerCount" value={inputFieldsEv1.offerCount} />
                      </div>
                    </div>
                  </Fragment>
                }

                <div className="col-6 ps-0">
                  <label>Aggregate rating value</label>
                  <div className="form-group me-2 mb-2">
                    <input type="number" onChange={(evnt) => handleChange5(evnt)} className='form-control' name="ratingValue" value={inputFieldsEv1.ratingValue} />
                  </div>
                </div>
                <div className="col-6 pe-0">
                  <label>Number of ratings</label>
                  <div className="form-group me-2 mb-2">
                    <input type="number" onChange={(evnt) => handleChange5(evnt)} className='form-control' name="ratingCount" value={inputFieldsEv1.ratingCount} />
                  </div>
                </div>
                <div className="col-6 ps-0">
                  <label>Highest value allowed</label>
                  <div className="form-group me-2 mb-2">
                    <input type="number" onChange={(evnt) => handleChange5(evnt)} className='form-control' name="bestRating" value={inputFieldsEv1.bestRating} />
                  </div>
                </div>
                <div className="col-6 pe-0">
                  <label>Lowest value allowed</label>
                  <div className="form-group me-2 mb-2">
                    <input type="number" onChange={(evnt) => handleChange5(evnt)} className='form-control' name="worstRating" value={inputFieldsEv1.worstRating} />
                  </div>
                </div>
                
              </div>
              
            { 
              inputFieldsEv.map((data, index) => {
                const { reviewname,reviewBody,rating,datePublished,author,publisher } = data;
                return (
                  <div className="row input_fields d-flex" key={index}>
                    <div className="col-md-4 col-sm-12">
                      <label>#{index+1} Review's name</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={reviewname} name="reviewname" className="form-control" placeholder="Review Name" />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <label>Review's body</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={reviewBody} name="reviewBody" className="form-control" placeholder="Review's Body" />
                      </div>
                    </div>                     
                    <div className="col-md-4 col-sm-12">
                      <label>Rating</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={rating} name="rating" className="form-control" placeholder="Rating" />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <label>Date</label>
                      <div className="form-group me-2 mb-2">
                        <input type="date" onChange={(evnt) => handleChange2(index, evnt)} value={datePublished} name="datePublished" className="form-control" placeholder="Date" />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <label>Auther</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={author} name="author" className="form-control" placeholder="Auther" />
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-11">
                      <label>Publisher</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={publisher} name="publisher" className="form-control" placeholder="Publisher" />
                      </div>
                    </div>
                    <div className="col-md-1 col-sm-1 text-center justify-content-center d-flex align-items-end mb-2">
                      {(inputFieldsEv.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsEv(index, evnt)}><i className="fa-solid fa-minus"></i></button> : ''}
                    </div>
                    { (inputFieldsEv.length > 1)? <hr/>:''}
                  </div>
                )
              })
            }
            <div className="col mt-3 mb-3">
              <button className="btn btn-primary addticket" onClick={addInputFieldEv}> <i className="fa-solid fa-plus"></i> Add Review</button>
            </div>
          </div>
          <div className='col-md-4'>
            <div className="card">
              <div className="card-header d-flex">
                <CopyToClipboard onCopy={onCopy} text={EvIsMyCopy} >
                  <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
                </CopyToClipboard> 
                  <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton> 
              </div>
              <div className="card-body">
                {EvIsMyCopy}
              </div>
              {copied && 
                <div className="card-footer text-muted">
                  <div className="p-2 btn-success rounded">✅ copied successfully</div>
                </div>
              }
            </div>
          </div>
        </div> 
    </div>
  );
}

export default Product